<template>
  <section class="hero">
    <div class="hero-background">
      <div class="grid-bg"></div>
      <div class="accent-line accent-top"></div>
      <div class="accent-line accent-right"></div>
    </div>
    
    <div class="hero-content">
      <div class="container">
        <!-- Hero 主标题区 -->
        <div class="hero-header">
          <h1 class="hero-title">{{ $t('hero.mainTitle') }}</h1>
          <p class="hero-subtitle">{{ $t('hero.mainSubtitle') }}</p>
        </div>

        <!-- 可信指标区 -->
        <div class="trust-metrics">
          <div class="metric-item">
            <div class="metric-number">{{ $t('hero.certCount') }}</div>
            <div class="metric-label">{{ $t('hero.certLabel') }}</div>
          </div>
          <div class="metric-divider"></div>
          <div class="metric-item">
            <div class="metric-number">{{ $t('hero.taskCount') }}</div>
            <div class="metric-label">{{ $t('hero.taskLabel') }}</div>
          </div>
          <div class="metric-divider"></div>
          <div class="metric-item">
            <div class="metric-number">{{ $t('hero.companyCount') }}</div>
            <div class="metric-label">{{ $t('hero.companyLabel') }}</div>
          </div>
        </div>

        <!-- 三阶段愿景：大括号括住初期+中期，箭头指向终极 -->
        <div class="goals-flow">
          <div class="goals-brace-group">
            <div class="goals-brace" aria-hidden="true">{</div>
            <div class="goals-phases">
              <div class="feature-tag">
                <span class="tag-dot">●</span>
                {{ $t('hero.verify') }}
              </div>
              <div class="feature-tag">
                <span class="tag-dot">●</span>
                {{ $t('hero.blockchain') }}
              </div>
            </div>
          </div>
          <div class="goals-arrow" aria-hidden="true">
            <svg width="48" height="24" viewBox="0 0 48 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 12H44M44 12L34 6V18L44 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="feature-tag feature-tag-ultimate">
            <span class="tag-dot">★</span>
            {{ $t('hero.realTasks') }}
          </div>
        </div>

        <!-- 三角色入口 -->
        <div class="role-grid">
          <router-link to="/enterprise" class="role-card">
            <div class="role-header">
              <span class="role-icon">→</span>
              <h3 class="role-title">{{ $t('hero.enterprise') }}</h3>
            </div>
            <p class="role-desc">{{ $t('hero.enterpriseDesc') }}</p>
            <div class="role-footer">
              <span class="role-meta">{{ $t('hero.enterpriseMeta') }}</span>
            </div>
          </router-link>

          <router-link to="/student" class="role-card">
            <div class="role-header">
              <span class="role-icon">→</span>
              <h3 class="role-title">{{ $t('hero.student') }}</h3>
            </div>
            <p class="role-desc">{{ $t('hero.studentDesc') }}</p>
            <div class="role-footer">
              <span class="role-meta">{{ $t('hero.studentMeta') }}</span>
            </div>
          </router-link>

          <router-link to="/investor" class="role-card">
            <div class="role-header">
              <span class="role-icon">→</span>
              <h3 class="role-title">{{ $t('hero.investor') }}</h3>
            </div>
            <p class="role-desc">{{ $t('hero.investorDesc') }}</p>
            <div class="role-footer">
              <span class="role-meta">{{ $t('hero.investorMeta') }}</span>
            </div>
          </router-link>
        </div>

        <!-- 行动按钮 -->
        <div class="hero-actions">
          <button class="action-button primary">
            {{ $t('hero.startBtn') }}
          </button>
          <button class="action-button secondary">
            {{ $t('hero.learnBtn') }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection'
}
</script>

<style scoped>
.hero {
  position: relative;
  min-height: 100vh;
  padding-top: 140px;
  padding-bottom: 60px;
  background: #020B1A;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.grid-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  opacity: 0.5;
}

/* 装饰线条 */
.accent-line {
  position: absolute;
  background: linear-gradient(90deg, rgba(0, 185, 255, 0.1), transparent);
  opacity: 0.3;
}

.accent-top {
  top: 15%;
  left: 0;
  right: 0;
  height: 1px;
}

.accent-right {
  top: 0;
  right: 15%;
  width: 1px;
  bottom: 0;
}

.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 标题区 */
.hero-header {
  margin-bottom: 4rem;
  max-width: 900px;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  color: #F9FAFB;
  line-height: 1.1;
  margin: 0 0 1.5rem 0;
  letter-spacing: -0.02em;
}

.hero-subtitle {
  font-size: 1.1rem;
  color: rgba(209, 213, 219, 0.85);
  line-height: 1.7;
  margin: 0;
  max-width: 700px;
}

/* 可信指标区 */
.trust-metrics {
  display: flex;
  gap: 2rem;
  margin-bottom: 4rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  align-items: center;
}

.metric-item {
  flex: 1;
}

.metric-number {
  font-size: 2.2rem;
  font-weight: 700;
  color: #00B9FF;
  margin-bottom: 0.5rem;
}

.metric-label {
  font-size: 0.9rem;
  color: rgba(209, 213, 219, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.metric-divider {
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
}

/* 三阶段愿景：大括号 + 箭头 → 终极 */
.goals-flow {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.goals-brace-group {
  display: flex;
  align-items: stretch;
  gap: 0;
}

.goals-brace {
  font-size: 4rem;
  font-weight: 300;
  color: rgba(0, 185, 255, 0.5);
  line-height: 1;
  display: flex;
  align-items: center;
  padding-right: 0.5rem;
  user-select: none;
}

.goals-phases {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.goals-arrow {
  color: rgba(0, 185, 255, 0.6);
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.goals-arrow svg {
  width: 40px;
  height: 20px;
}

.feature-tag {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-size: 0.95rem;
  color: rgba(209, 213, 219, 0.8);
  padding: 0.8rem 1.2rem;
  background: rgba(0, 185, 255, 0.05);
  border: 1px solid rgba(0, 185, 255, 0.15);
  border-radius: 6px;
}

/* 终极目标：箭头指向的终点，特殊样式 */
.feature-tag-ultimate {
  flex-shrink: 0;
  min-width: 260px;
  font-size: 1.05rem;
  font-weight: 600;
  color: #F9FAFB;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, rgba(0, 185, 255, 0.12) 0%, rgba(138, 43, 226, 0.08) 100%);
  border: 1px solid rgba(0, 185, 255, 0.35);
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0, 185, 255, 0.15);
  white-space: normal;
}

.feature-tag-ultimate .tag-dot {
  color: #00B9FF;
  font-size: 1rem;
  filter: drop-shadow(0 0 6px rgba(0, 185, 255, 0.5));
}

.tag-dot {
  color: #00B9FF;
  font-size: 0.8rem;
}

/* 三角色卡片网格 */
.role-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 3rem;
}

.role-card {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 2rem;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.role-card:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(0, 185, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 185, 255, 0.08);
  transform: translateY(-4px);
}

.role-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.role-icon {
  font-size: 1.2rem;
  color: #00B9FF;
  font-weight: 700;
}

.role-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #F9FAFB;
  margin: 0;
}

.role-desc {
  font-size: 0.95rem;
  color: rgba(209, 213, 219, 0.75);
  line-height: 1.6;
  margin: 0;
  flex-grow: 1;
}

.role-footer {
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.role-meta {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 500;
}

/* 行动按钮 */
.hero-actions {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.action-button {
  padding: 14px 32px;
  font-size: 0.95rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.action-button.primary {
  background: linear-gradient(135deg, #00B9FF, #00E5CC);
  color: #020B1A;
}

.action-button.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(0, 185, 255, 0.25);
}

.action-button.secondary {
  background: transparent;
  color: #F9FAFB;
  border: 1.5px solid rgba(255, 255, 255, 0.2);
}

.action-button.secondary:hover {
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.05);
  transform: translateY(-2px);
}

@media (max-width: 1024px) {
  .hero-title {
    font-size: 2.8rem;
  }

  .role-grid {
    grid-template-columns: 1fr;
  }

  .trust-metrics {
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .hero {
    padding-bottom: 40px;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .trust-metrics {
    flex-direction: column;
    gap: 1.5rem;
    padding-bottom: 2rem;
  }

  .metric-divider {
    display: none;
  }

  .goals-flow {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .goals-brace-group {
    justify-content: center;
  }

  .goals-brace {
    font-size: 2.5rem;
  }

  .goals-phases {
    gap: 0.5rem;
  }

  .goals-arrow {
    justify-content: center;
  }

  .goals-arrow svg {
    transform: rotate(90deg);
    width: 28px;
    height: 14px;
  }

  .feature-tag-ultimate {
    min-width: 0;
    font-size: 1rem;
    padding: 1rem 1.2rem;
  }

  .hero-actions {
    flex-direction: column;
  }

  .action-button {
    width: 100%;
    text-align: center;
  }

  .container {
    padding: 0 1rem;
  }
}
</style>
